<template>
  <div class="lab-form-content">
    <div class="w-full mb-6">
      <label class="vs-input--label">Skill Area ID</label>
      <vx-input-group
        class="mb-base"
        prependClasses="border border-solid border-grey border-r-0"
      >
        <vs-input
          v-model="localSonar.SkillArea.id"
          placeholder="Enter Skill Sonar ID from ARGUS"
          class="auto-alias-field"
          @blur="saveSonar(localSonar)"
          :disabled="isEditing"
        />
        <template slot="append">
          <div class="append-btn-wrapper ml-4">
            <vs-button
              class="append-btn"
              @click="fetchSkillAreaByID"
              :disabled="!localSonar.SkillArea.id"
            >
              Fetch
            </vs-button>
          </div>
        </template>
      </vx-input-group>
    </div>

    <div
      id="lab-async-api-data-2"
      class="flex mt-4 flex-wrap vs-con-loading__container"
    >
      <div class="w-1/2 pb-5 pr-3">
        <label class="vs-input--label">Learning Area</label>
        <v-select
          v-model="localSonar.LearningArea.name"
          placeholder="Select a learning area"
          :options="learningAreaOptions"
          @input="onLearningAreaChange"
          :disabled="isEditing"
        />
      </div>
      <div class="w-1/2 pb-5">
        <label class="vs-input--label">Learning Area Group</label>
        <v-select
          v-model="localSonar.LearningAreaGroup.name"
          placeholder="Select a learning area group"
          :options="learningGroupOptions"
          @input="onLearningAreaGroupChange"
          :disabled="!localSonar.LearningArea.id || isEditing"
        />
      </div>
    </div>

    <div class="w-full mb-6">
      <label class="vs-input--label">Skill Area</label>
      <vs-input
        v-model="localSonar.SkillArea.name"
        placeholder="Enter skill area"
        class="w-full"
        @blur="saveSonar(localSonar)"
      />
    </div>

    <div class="flex w-full mt-5 mb-5 items-center space-x-4">
      <!-- New Beta Field -->
      <div class="flex items-center mt-3">
        <vs-switch
          v-model="localSonar.SkillArea.is_beta"
          @input="saveSonar(localSonar)"
          class="mr-2"
        />
        <label>Is Beta</label>
      </div>

      <!-- New Category Field -->
      <div class="flex-1">
        <label class="vs-input--label">Category</label>
        <vs-input
          v-model="localSonar.SkillArea.category"
          placeholder="Enter category"
          class="w-full"
          @blur="saveSonar(localSonar)"
        />
      </div>
    </div>

    <template v-if="localSonar.summary.length > 0">
      <label class="vs-input--label">Assessment Summary</label>
      <vs-table :data="localSonar.summary">
        <template slot="thead">
          <vs-th>Difficulty</vs-th>
          <vs-th>Assessments</vs-th>
          <vs-th>Total Labs</vs-th>
          <vs-th>Total Questions</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr v-for="(tr, indextr) in data" :key="indextr">
            <vs-td>{{ tr.difficulty }}</vs-td>
            <vs-td>{{ tr.configCount }}</vs-td>
            <vs-td>{{ tr.labs }}</vs-td>
            <vs-td>{{ tr.questions }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </template>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
import cloneDeep from 'lodash.clonedeep'

export default {
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      localSonar: {
        SkillArea: { name: '', id: null },
        LearningAreaGroup: { name: '', id: null },
        LearningArea: { name: '', id: null },
        summary: [],
      },
    }
  },
  watch: {
    getCurrentSonar(newValue) {
      this.localSonar = cloneDeep(newValue)
    },
  },
  computed: {
    ...mapGetters('sonar', ['getCurrentSonar']),
    ...mapState('sonarlareas', ['learningAreas']),
    ...mapGetters('sonarlareas', ['learningAreaNames', 'selectedAreaGroups']),
    learningAreaOptions() {
      return Object.keys(this.learningAreas).map((area) => ({
        label: area,
        value: area,
      }))
    },
    learningGroupOptions() {
      return this.selectedAreaGroups.map((group) => ({
        label: group.name,
        value: group.id,
      }))
    },
    isEditing() {
      return this.$route.name === 'edit-sonar'
    },
  },
  methods: {
    ...mapMutations('sonar', { saveSonar: 'STORE_CURRENT_SONAR_ASSESSMENT' }),
    ...mapActions('sonar', ['getSonarAssessmentById']),
    ...mapActions('sonarlareas', ['getAllSonarLAreas', 'selectLearningArea']),
    onLearningAreaChange(selectedArea) {
      const area = this.learningAreas[selectedArea.value]
      this.localSonar.LearningArea = { id: area.id, name: selectedArea.value }
      this.localSonar.LearningAreaGroup = { name: '', id: null }
      this.selectLearningArea(selectedArea.value)
      this.saveSonar(this.localSonar)
    },
    onLearningAreaGroupChange(selectedGroup) {
      this.localSonar.LearningAreaGroup = {
        id: selectedGroup.value,
        name: selectedGroup.label,
      }
      this.saveSonar(this.localSonar)
    },
    async fetchSkillAreaByID() {
      try {
        this.$vs.loading()
        await this.getSonarAssessmentById(this.localSonar.SkillArea.id)
      } catch (error) {
        this.showError(error.response.data)
      } finally {
        this.$vs.loading.close()
      }
    },
  },
  async created() {
    this.localSonar = cloneDeep(this.getCurrentSonar)
    try {
      this.$vs.loading()
      await this.getAllSonarLAreas()
    } catch (error) {
      this.showError(error.response.data)
    } finally {
      this.$vs.loading.close()
    }
  },
}
</script>
<style lang="scss">
.vs-con-loading__container {
  position: relative;
  overflow: unset;
}
</style>
